import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const huggingFace = defineConnector({
  identifier: "huggingFace",
  name: "Hugging Face",
  tagLine: "AI model hub and inference API",
  keywords: "hf transformers inference endpoints models hub llm",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () =>
    "https://.*\\.huggingface\\.co/.*|https://router\\.huggingface\\.co/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Hugging Face Settings](https://huggingface.co/settings/tokens) and create a new access token with the appropriate permissions. See the [API docs](https://huggingface.co/docs/api-inference/) for details.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          placeholder: "hf_...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://huggingface.co/api/whoami-v2",
  },
});
